import React from 'react';

import { Search } from 'lucide-react';

import Input from './Input';

import type { LucideIcon } from 'lucide-react';

export interface SearchInputProps {
	placeholder?: string;
	value?: string;
	onChange?: (value: string) => void;
	className?: string;
	onClear?: () => void;
	rightIcon?: LucideIcon;
}

const SearchInput: React.FC<SearchInputProps> = ({
	placeholder = 'Search',
	value = '',
	onChange,
	className = '',
	onClear,
	rightIcon,
	...props
}) => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		onChange?.(e.target.value);
	};

	return (
		<Input
			leftIcon={Search}
			variant="filled"
			type="text"
			value={value}
			onChange={handleChange}
			placeholder={placeholder}
			className={`bg-black/5 outline-none text-zinc-500 text-sm font-normal ${className}`}
			rightIcon={rightIcon}
			onRightIconClick={onClear}
			{...props}
		/>
	);
};

export default SearchInput;
